// V17 Neon Atelier design tokens.
export const tokens = {
  bg: "#060606",
  bgSoft: "#0c0c0c",
  surface: "rgba(255,255,255,0.04)",
  primary: "#fff",
  muted: "#e3e3d8",
  faint: "rgba(255,255,255,0.55)",
  accent: "#c8ff2a", // lime
  accentHot: "#ff2a8f", // hot pink
  accentCool: "#2ad6ff", // cyan
  border: "rgba(255,255,255,0.12)",
  borderStrong: "rgba(255,255,255,0.32)",
  fontDisplay: "'Azeret Mono', 'JetBrains Mono', monospace",
  fontBody: "'Outfit', system-ui, sans-serif",
  fontMono: "'JetBrains Mono', monospace",
};

export const LOGO_CIRCLE =
  "https://customer-assets.emergentagent.com/job_fault-line-pitch/artifacts/wd6e4sfz_logo_circle.png";
export const LOGO_SQUARE =
  "https://customer-assets.emergentagent.com/job_fault-line-pitch/artifacts/9fmb2f9x_logo_square.png";
